import { render, staticRenderFns } from "./AllowableFeeScheduleCodes.vue?vue&type=template&id=e14fb564&scoped=true"
import script from "./AllowableFeeScheduleCodes.vue?vue&type=script&lang=js"
export * from "./AllowableFeeScheduleCodes.vue?vue&type=script&lang=js"
import style0 from "./AllowableFeeScheduleCodes.vue?vue&type=style&index=0&id=e14fb564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e14fb564",
  null
  
)

export default component.exports